import { render, staticRenderFns } from "./DisplayV2.vue?vue&type=template&id=3aad06ca&scoped=true&"
import script from "./DisplayV2.vue?vue&type=script&lang=js&"
export * from "./DisplayV2.vue?vue&type=script&lang=js&"
import style0 from "./DisplayV2.vue?vue&type=style&index=0&id=3aad06ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad06ca",
  null
  
)

export default component.exports